import http from './services/http'
import {AxiosResponse} from 'axios'

const getFeatureFlags = (): Promise<AxiosResponse> => {
    return http.get('/featureFlags')
}

export default {getFeatureFlags}